import { createSelector } from 'reselect'

const getUserData = state => state.user

const storefrontVisitorIsLoggedIn = createSelector(
	[ getUserData ],
	userState => userState.logged
)

export default storefrontVisitorIsLoggedIn
